import {TranslationService} from "./translation.service";
import { currencyConversion } from "./CurrencyConversion.function";
import { Currency } from "../common";

export class CurrencyHandler {

    constructor(
        private templateCurrency: string,
        private localCurrency: string,
        private conversionRate: string,
        private showDoubleCurrency: boolean,
    ) {
    }

    public get isSecondaryCurrencyDisplayed(): boolean {
        return this.showDoubleCurrency;
    }

    public get isCurrencyDisplaySwitched(): boolean {
        return this.showDoubleCurrency && this.secondaryCurrency === Currency.EUR;
    }

    public displayPrimaryCurrency(amount: number): string {
        return this.isCurrencyDisplaySwitched ? this.getSecondaryCurrency(amount) : this.getPrimaryCurrency(amount);
    }

    public displaySecondaryCurrency(amount: number): string {
        if (!this.isSecondaryCurrencyDisplayed) {
            return '';
        }

        return this.isCurrencyDisplaySwitched ? this.getPrimaryCurrency(amount) : this.getSecondaryCurrency(amount);
    }

    private getPrimaryCurrency(amount: number) {
        return this.assertCurrencyFormat(this.priceFormatter.format(amount));
    }

    private getSecondaryCurrency(amount: number) {
        return this.assertCurrencyFormat(this.secondaryPriceFormatter.format(this.convertToSecondaryCurrency(amount)));
    }

    private get priceFormatter(): Intl.NumberFormat {
        return new Intl.NumberFormat(`${TranslationService.getLocale()}`, {
            style: 'currency',
            currency: TranslationService.getIsoCurrencyFor(this.templateCurrency)
        });
    }

    private get secondaryPriceFormatter(): Intl.NumberFormat {
        return new Intl.NumberFormat(`${TranslationService.getLocale()}`, {
            style: 'currency',
            currency: TranslationService.getIsoCurrencyFor(this.secondaryCurrency)
        });
    }

    private get hasHRK(): boolean {
        return TranslationService.getIsoCurrencyFor(this.templateCurrency) === Currency.HRK || TranslationService.getIsoCurrencyFor(this.secondaryCurrency) === Currency.HRK;
    }

    private get secondaryCurrency(): string {
        return TranslationService.getIsoCurrencyFor(this.localCurrency) === TranslationService.getIsoCurrencyFor(this.templateCurrency) ? Currency.EUR : this.localCurrency;
    }

    private assertCurrencyFormat(amount: string): string {
        if (amount.toLowerCase().includes('kn') && this.hasHRK) {
            return amount.toLowerCase().replace('kn', Currency.HRK);
        }

        return amount;
    }

    private convertToSecondaryCurrency(amount: number): number {
        return currencyConversion(amount, +this.conversionRate, this.secondaryCurrency === Currency.EUR);
    }
}
